<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          v-if="walletId"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          v-on="on"
        >
          <span>
            Wallet-ID <b>({{ walletId }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyWalletId"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-if="walletAddress"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          v-on="on"
        >
          <span>
            Wallet Address <b>({{ walletAddress }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyWalletAddress"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-if="username"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          v-on="on"
        >
          <span>
            Username <b>({{ username }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyUsername"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Copy Content or visit Link
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'VaultChip',
  props: {
    walletId: {
      type: [String, Number],
      default: null,
      required: false,
    },
    walletAddress: {
      type: [String, Number],
      default: null,
      required: false,
    },
    username: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  methods: {
    async copyWalletId() {
      await navigator.clipboard.writeText(this.walletId);
      this.snackbarText = `Wallet-ID ${this.walletId} copied to clipboard`;
      this.snackbar = true;
    },
    async copyWalletAddress() {
      await navigator.clipboard.writeText(this.walletAddress);
      this.snackbarText = `Wallet Address ${this.walletAddress} copied to clipboard`;
      this.snackbar = true;
    },
    async copyUsername() {
      await navigator.clipboard.writeText(this.username);
      this.snackbarText = `Username ${this.username} copied to clipboard`;
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mp-hip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/vault/VaultChip.vue